export const convertArraytoSelectOptionsList = (arr, type) => {
  if (Array.isArray(arr)) {
    return arr.map((a) => {
      return {
        key: a === "" ? type : a,
        value: a === "" ? "All" : a,
        text: a === "" ? "All" : a,
      };
    });
  }
};

export const getGroupCheckOptions = (arr, defautlSelctionOpt = []) => {
  if (Array.isArray(arr)) {
    return arr.map((a) => {
      return {
        name: a,
        value: a,
        id: a,
        checked: defautlSelctionOpt.includes(a),
      };
    });
  }
};


export const getPrescriptionByStatusData = (list, arr = []) => {
  return list.filter(l => arr.includes(l.rxInfo.rxStatus))
}